import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { ActivityPackStatus, ActivityStatusType } from '../../../models/instance/activity-pacck-type.model';
import { CreateActivityPackStatusModalComponent } from '../../modals/organization/create-activity-pack-status-modal/create-activity-pack-status-modal.component';

@Component({
    selector: 'app-instance-activity-pack-status',
    templateUrl: './instance-activity-pack-status.component.html',
    styleUrls: ['./instance-activity-pack-status.component.scss'],
})
export class InstanceActivityPackStatusComponent implements OnInit {
    @Input() activityPackTypeStatusList: ActivityPackStatus[];
    @Output() newStatusColor = new EventEmitter<ActivityPackStatus[]>();
    @ViewChild(MatTable) table: MatTable<any>;

    activityPackTemp: ActivityPackStatus[];
    tooltip_position = 'above';
    displayedColumns: string[] = ['name', 'color'];
    dataSource;
    temp1 = [];
    tempObj: ActivityPackStatus[];
    constructor(
        private instanceDataService: InstanceDataService,
        private ngbModal: NgbModal
    ) {}

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<ActivityStatusType>(this.instanceDataService.activityStatusTypes);
    }

    checkUncheck(event, element) {
        this.tempObj.forEach((item) => {
            if (item.name === element.name) {
                item.isSelected = event.checked;
            }
        });
        this.newStatusColor.emit(this.tempObj);
    }

    temp(element) {
        this.newStatusColor.emit(this.tempObj);
        let index = this.findIndexOfActivityTypeStatus(element.name, this.tempObj);
        let otherIndex = this.findIndexOfActivityTypeStatus(element.name, this.activityPackTemp);
        this.activityPackTemp[otherIndex] = this.tempObj[index];
        this.newStatusColor.emit(this.activityPackTemp);
    }

    // function to view activity pack status
    viewStatusDetails(activityStatus: ActivityPackStatus) {
        let dialogRef = this.ngbModal.open(CreateActivityPackStatusModalComponent, {
            size: 'md',
        });
        dialogRef.componentInstance.modalMode = 'edit';
        let index = this.findIndexOfActivityTypeStatus(activityStatus.name, this.tempObj);
        let otherIndex = this.findIndexOfActivityTypeStatus(activityStatus.name, this.activityPackTemp);
        dialogRef.componentInstance.activityStatusDetails = activityStatus;
        dialogRef.componentInstance.defaultStatusList = this.activityPackTemp;
        dialogRef.result
            .then((result) => {
                if (result) {
                    this.tempObj[index] = result;
                    this.activityPackTemp[otherIndex] = result;
                    this.table.renderRows();
                    this.newStatusColor.emit(this.activityPackTemp);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // function to add the new activity pack status
    addNewActivityPackStatus() {
        // let dialogRef = this.ngbModal.open(CreateActivityPackStatusModalComponent, {
        //   size: "md",
        // });
        // dialogRef.componentInstance.modalMode = "add";
        // dialogRef.componentInstance.defaultStatusList = this.activityPackTemp;
        // dialogRef.result
        //   .then((result) => {
        //     console.log(result);
        //     if(result){
        //       this.tempObj.push(result);
        //       this.activityPackTemp.push(result);
        //       this.table.renderRows();
        //       this.newStatusColor.emit(this.activityPackTemp);
        //     }
        //   })
        //   .catch((error) => {});
    }

    // function to delete the activity pack status
    deleteActivityStatus(activityPackStatus: ActivityPackStatus) {
        let dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
        });
        let index = this.findIndexOfActivityTypeStatus(activityPackStatus.name, this.tempObj);
        let otherIndex = this.findIndexOfActivityTypeStatus(activityPackStatus.name, this.activityPackTemp);
        dialogRef.componentInstance.modalMessage = `<p>Do you want to delete <b>${activityPackStatus.name}</b> project type status? </p>`;
        dialogRef.result
            .then((result: ActivityPackStatus) => {
                if (result) {
                    if (activityPackStatus.activityPackTypeStatusId) {
                        activityPackStatus.active = false;
                        this.activityPackTemp[otherIndex] = activityPackStatus;
                        this.tempObj.splice(index, 1);
                        this.table.renderRows();
                        this.newStatusColor.emit(JSON.parse(JSON.stringify(this.activityPackTemp)));
                    } else {
                        this.tempObj.splice(index, 1);
                        this.activityPackTemp.splice(otherIndex, 1);
                        this.table.renderRows();
                        this.newStatusColor.emit(JSON.parse(JSON.stringify(this.activityPackTemp)));
                    }
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // helper method to get the index of particular activity type
    findIndexOfActivityTypeStatus(activityPackStatusName: string, activityPackStatusArray: ActivityPackStatus[]) {
        let index = -1;
        for (const [index, activityPackStatus] of activityPackStatusArray.entries()) {
            if (activityPackStatus.name.toLocaleLowerCase().replace(/ /g, '') === activityPackStatusName.toLocaleLowerCase().replace(/ /g, '')) {
                return index;
            }
        }
        return index;
    }
}
